import { safe } from '../utils/contrast.js';
import { estiloDeBoton } from '../utils/boton-estilo.js';
import { parseVideoUrl, renderVideoBackground } from '../utils/videoEmbed.js';
import { ctaAnchorAttrs } from '../utils/links.js';
import { conSecundario } from '../utils/boton-secundario.js';
import { escapeHtml } from '../utils/dom.js';

// ── VIDEO / MEDIA SECTION ────────────────────────────────────────
// El secundario (utils/boton-secundario.js): del tamaño del principal y con el texto BLANCO del bloque (va
// sobre el vídeo con su velo oscuro, no sobre el color de la sección).
const SECUNDARIO_VIDEO = 'padding: calc(18px * var(--n3b-k, 1)) calc(48px * var(--n3b-k, 1)); font-size: calc(1.05rem * var(--n3b-k, 1)); --text: #ffffff;';

export const videoBlock = (rawProps) => {
    const p = safe(rawProps);
    const title = p.title || 'Vive la Experiencia';
    const subtitle = p.subtitle || 'Un mensaje poderoso que conecta con tu audiencia.';
    const cta = p.cta || 'Comenzar Ahora';
    const videoUrl = p.video_url || '';
    const isVideo = !!videoUrl && videoUrl !== 'placeholder';
    const { type: videoType } = parseVideoUrl(videoUrl);
    const fallbackBg = p.image_url || '';

    const bgStyle = isVideo
        ? ''
        : fallbackBg
            // Escapada: va DENTRO del `style` de la <section>; sin escapar, un `"` en la URL cerraba
            // el atributo y colaba un `on*` (revisor del P2) y un `>` rompía las inyecciones del render.
            ? `background:url('${escapeHtml(fallbackBg)}') center/cover no-repeat;`
            : `background:linear-gradient(135deg, #0f0c29, #302b63, #24243e);`;

    // El botón de play/pausa solo tiene sentido con MP4 nativo (no iframe)
    const isNativeMp4 = isVideo && videoType === 'mp4';
    const playPauseBtn = isNativeMp4 ? `
        <button class="video-play-btn" type="button">
            <svg class="play-icon" style="display:none;" viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M8 5v14l11-7z"/></svg>
            <svg class="pause-icon" style="display:block;" viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
        </button>` : '';

    return `
    <section id="bloque-video" class="reveal video-hero-section variant-${p.variant || 'v1'}"
             style="--accent:${p.accentColor || '#6366f1'}; --accent-contrast:#fff; --font:'${p.fontFamily || "Inter"}'; ${bgStyle} position:relative; overflow:hidden; min-height:90vh; display:flex; align-items:center; justify-content:center; text-align:center; padding:0 8%;">
        ${isVideo ? renderVideoBackground(videoUrl) : ''}
        <!-- Overlay oscuro con gradiente para legibilidad -->
        <div style="position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,0.35) 0%,rgba(0,0,0,0.6) 100%);z-index:1;"></div>

        <div style="position:relative;z-index:2;max-width:900px;">
            <h1 data-field="title" contenteditable="true"
                style="font-size:calc(clamp(2.5rem,7cqw,5.5rem) * var(--type-scale, 1) * var(--title-adj, 1)); font-weight:var(--display-weight, 900); line-height:1.05; color:#ffffff; margin-bottom:28px; text-shadow:0 2px 30px rgba(0,0,0,0.4); letter-spacing:-1px;">${title}</h1>
            <p data-field="subtitle" contenteditable="true"
               style="font-size:calc(clamp(1rem,2.5cqw,1.4rem) * var(--text-scale, 1)); color:rgba(255,255,255,0.85); margin-bottom:48px; max-width:680px; margin-inline:auto; line-height:1.6;">${subtitle}</p>
            ${playPauseBtn}
            ${conSecundario(`<a ${ctaAnchorAttrs(p.cta_url)} class="btn-action" data-field="cta" contenteditable="true"
               style="${estiloDeBoton(p, 'cta')}display:inline-block; padding:calc(18px * var(--n3b-k, 1)) calc(48px * var(--n3b-k, 1)); border-radius:var(--n3b-radius, var(--btn-radius, 50px)); font-weight:800; font-size:calc(1.05rem * var(--n3b-k, 1)); text-decoration:none; box-shadow:var(--n3b-shadow, 0 8px 30px rgba(0,0,0,0.3));">${cta}</a>`, p, { boton: SECUNDARIO_VIDEO })}
        </div>

        <div class="video-hero-placeholder editor-only" style="position:absolute;bottom:24px;left:50%;transform:translateX(-50%);z-index:3;display:flex;align-items:center;gap:8px;background:rgba(15,15,20,0.85);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,0.12);border-radius:var(--card-radius, 30px);padding:10px 20px;color:#e2e8f0;font-size:0.8rem;font-weight:600;cursor:pointer;white-space:nowrap;" title="Configurar video">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
            ${isVideo ? 'Cambiar video' : 'Añadir video'}
        </div>
    </section>`;
};
